import { useCallback } from 'react';

import { EntryProps, getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

export const ConversationFollowup = ({ entry }: EntryProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : null;

  const action = useCallback((): string => {
    switch (entry.activity_type) {
      case 'FOLLOWUP_ADDED':
        return 'set';
      case 'FOLLOWUP_EXPIRED':
        return 'expired';
      case 'FOLLOWUP_REMOVED':
        return 'cancelled';
      default:
        console.warn(`Unknown follow-up type ${entry.activity_type}`);
        return 'unknown';
    }
  }, [entry]);

  const text = (
    <>
      Follow-up is {action()} {authorLink && <>by {authorLink}</>}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
